module.exports = "<p> {{successText}} </p> <a class=\"button button-beta\" ng-click=close() ng-href=/posts/create/{{formId}} translate=notify.form.add_to_survey>Add to survey</a> <button class=\"button-flat message-trigger\" ng-click=close() translate=message.button.dismiss> Dismiss </button> ";


//////////////////
// WEBPACK FOOTER
// ./app/settings/surveys/survey-success.html
// module id = 842
// module chunks = 0